<template>
    <div class="w-full  bg-gray-50 flex flex-row">



        <div class="relative  mt-2 mb-2 w-72 bg-orange-100">
            <div
                class="w-full text-gray-900 bg-white border border-gray-200 rounded-lg   ">
                <button v-for="pdf in source2" :key="pdf.file_id" type="button" @click="OnSelectChoice(pdf)"
                    class="relative inline-flex items-center w-full px-4 py-2 text-sm font-medium border-b border-gray-200 rounded-t-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700    ">
                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor" viewBox="0 0 20 20">
                        <path
                            d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                    </svg>
                    {{pdf.name}} <br>    {{pdf.subname}}
                </button>
                <button type="button"
                    class="hidden relative inline-flex items-center w-full px-4 py-2 text-sm font-medium border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700    ">
                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 20 20">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M7.75 4H19M7.75 4a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 4h2.25m13.5 6H19m-2.25 0a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 10h11.25m-4.5 6H19M7.75 16a2.25 2.25 0 0 1-4.5 0m4.5 0a2.25 2.25 0 0 0-4.5 0M1 16h2.25" />
                    </svg>
                    Settings
                </button>
                <button type="button"
                    class="hidden relative inline-flex items-center w-full px-4 py-2 text-sm font-medium border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700    ">
                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 18" fill="currentColor">
                        <path
                            d="M18 4H16V9C16 10.0609 15.5786 11.0783 14.8284 11.8284C14.0783 12.5786 13.0609 13 12 13H9L6.846 14.615C7.17993 14.8628 7.58418 14.9977 8 15H11.667L15.4 17.8C15.5731 17.9298 15.7836 18 16 18C16.2652 18 16.5196 17.8946 16.7071 17.7071C16.8946 17.5196 17 17.2652 17 17V15H18C18.5304 15 19.0391 14.7893 19.4142 14.4142C19.7893 14.0391 20 13.5304 20 13V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4Z"
                            fill="currentColor" />
                        <path
                            d="M12 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V9C0 9.53043 0.210714 10.0391 0.585786 10.4142C0.960859 10.7893 1.46957 11 2 11H3V13C3 13.1857 3.05171 13.3678 3.14935 13.5257C3.24698 13.6837 3.38668 13.8114 3.55279 13.8944C3.71889 13.9775 3.90484 14.0126 4.08981 13.996C4.27477 13.9793 4.45143 13.9114 4.6 13.8L8.333 11H12C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0Z"
                            fill="currentColor" />
                    </svg>
                    Messages
                </button>
                <button type="button"
                    class="hidden relative inline-flex items-center w-full px-4 py-2 text-sm font-medium rounded-b-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700    ">
                    <svg class="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor" viewBox="0 0 20 20">
                        <path
                            d="M14.707 7.793a1 1 0 0 0-1.414 0L11 10.086V1.5a1 1 0 0 0-2 0v8.586L6.707 7.793a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.416 0l4-4a1 1 0 0 0-.002-1.414Z" />
                        <path
                            d="M18 12h-2.55l-2.975 2.975a3.5 3.5 0 0 1-4.95 0L4.55 12H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Zm-3 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
                    </svg>
                    Download
                </button>
            </div>

        </div>
 

        <div class="relative mt-2 mb-2  w-full flex mx-auto  justify-center">



            <div class="min-h-96 max-w-5xl w-full">
                <nav
                    class=" border-gray-200 px-4 lg:px-6 py-2.5  justify-between flex flex-row items-center">
                    <div class=" justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2">
                        <ul
                            class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 justify-end w-full  ">
                            <li>
                                <a href="#" @click="onGenerate(pdf)"
                                    v-if="(current_pdf.id != '') && (!(config?.buttons?.generate == false))"
                                    class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                                    aria-current="page"><i class="fa-brands fa-creative-commons-share"></i> Générer</a>
                            </li>
                        </ul>
                    </div>
                    <div class="  justify-between items-center w-full lg:flex lg:w-auto lg:order-1" id="mobile-menu-2"
                        v-if="!isLoading">
                        <ul
                            class="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0 justify-end w-full  ">
                            <li v-if="!(config?.buttons?.refresh == false)">
                                <a href="#" @click="onRefresh(pdf)"
                                    class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                                    aria-current="page"><i class="fa-solid fa-arrows-rotate"></i> Rafraîchir </a>
                            </li>
                            <li v-if="(current_pdf.id != '') && (!(config?.buttons?.download == false))">
                                <a href="#" @click="onDownload(pdf)"
                                    class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold"
                                    aria-current="page"><i class="fa-solid fa-download mr-1"></i> Télécharger </a>
                            </li>
                            <li v-if="(current_pdf.id != '') && (!(config?.buttons?.print == false))" class="hidden">
                                <a href="#" @click="printPDF(pdf)"
                                    class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold">
                                    <i class="fa-solid fa-print mr-1"></i> Imprimer</a>
                            </li>
                            <li v-if="(current_pdf.id != '') && (!(config?.buttons?.email == false))">
                                <a href="#" @click="onResend(pdf)"
                                    class="block py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 lg:hover:text-primary-700 lg:p-0    text-sm font-bold">
                                    <i class="fa-solid fa-share mr-1"></i> Renvoyer</a>
                            </li>
                        </ul>
                    </div>
                </nav>
   
 
                <vue-pdf-embed :ref="el => storePdfRef(el, current_pdf.id)"   class="w-full"
                    :source="current_pdf.url" :data-pdf-ref="`pdf-${current_pdf.id}`" @loaded="handleDocumentLoad"
                    v-if="current_pdf.id != ''" @rendered="handleDocumentRender" />
            </div>

        </div>







    </div>
</template>


<script>
    // import service from "@/services/FullService.vue"
    import { mapGetters } from "vuex";
    import VuePdfEmbed from 'vue-pdf-embed'


    export default {
        name: 'ContentPDFs',
        components: {
            VuePdfEmbed,
        },
        props: {
            id: String,
            label: String,
            placeholder: String,
            required: Boolean,
            value: Object,
            record: Object,
            isActive: Boolean,
            currentTab: Number,
            indexTab: Number,
            config: Object
        },
        computed:
        {
            ...mapGetters({ user: "StateUser" }),
            mapRef: function (a) {
                if (a == undefined) return null;
                return a;
            },
            showButtons() {
                // if (this.$route.params.id == "inbound-invoices") return false
                return true;
            }
        },

        data() {
            return {
                current_pdf: { id: "67c33ee372e34e374dfc9798", name: "test.pdf", url: "http://files.b4food.io/b4food/files/67c33ee372e34e374dfc9798" },
                pdfRefs: {},
                source2: [],
                source3: "",
                output: "",

                isLoading: true,
                page: null,
                pageCount: null,
                c: 0
            }
        },
        watch: {
            isActive: async function (val) {

                if (this.value == undefined) { this.isLoading = false; this.source2 = ""; return }

           
                let path = "files"


                if (this.config.path) path = this.config.path


                if (val == true) {

                    if (Array.isArray(this.value)) {

                        let ar = [];
                        for (let i = 0; i < this.value.length; i++) ar.push({ id: this.value[i].file_id, url: "https://files.b4food.io/b4food/" + path + "/" + this.value[i].file_id })

                        this.source2 = ar
                    }
                    else {
                        let ar = [];
                        ar.push({ id: this.value, url: "https://files.b4food.io/b4food/" + path + "/" + this.value.file_id })
                        this.source2 = ar
                    }

                    // //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value

                    
                    // this.source2 = "https://files.b4food.io/b4food/images/" + this.value[0]


                    //let ar = [];
                    //for (let i = 0; i < this.value.length; i++) ar.push("https://files.b4food.io/b4food/images/" + this.value[i])
                    //  this.source2 = "https://files.b4food.io/b4food/files/" + this.value
                    //   this.source2 = ar
                }

                else
                    this.source2 = []
            },
            currentTab: async function (/*val*/) {
                 
            },

            indexTab: async function (/*val*/) {
          
            },


            value: async function (val) {
                this.output = val;

                if (val == undefined) { this.isLoading = false; return }

                if (this.value != undefined) {

                    this.c++


                }
            }
        },

        async mounted() {

            this.output = this.value;
            if (this.value != undefined) {




                //  let pdf = await service.getDataId("files/base64", this.value, this.user?.token, { fields: 'id,name, data' })


                this.source3 = "https://files.b4food.io/b4food/files/" + this.value

            }


            /*
                        this.$nextTick(function () {
                            window.scrollTo(0, 0)
                        }); */
        },
        methods: {
            OnSelectChoice(pdf) {

            
                this.current_pdf = pdf 



            },
            storePdfRef(el, id) {
          

                if (el) {
                    this.pdfRefs[id] = el
                }
                //   if (el) {
                //       this.pdfRefs = { ...this.pdfRefs, [id]: el }; // Ajoute ou met à jour la référence
                //   } 

                //  else {
                //      const { [id]: removed, ...rest } = this.pdfRefs; // Supprime la référence si nécessaire
                //      this.pdfRefs = rest;
                //  }
            },


            handleDocumentRender() {
            
                this.isLoading = false
            },
            handleDocumentLoad(numPages) {
           

                this.pageCount = numPages.numPages
            },
            onDownload: function (pdf) {
                let name = "download.pdf"
                let id = 'pdf-' + pdf.id

                if (this.pdfRefs[pdf.id]) {
                    this.pdfRefs[pdf.id].download(name); // Appelle la méthode download de l'instance
                } else {
                    console.error(`PDF with ID ${id} not found.`);
                }


                /*
                                let name = "download.pdf"
                                if (this.record.pdf_file_name) name = this.record.pdf_file_name
                
                                if (this.$refs[id]) { this.$refs[id].download(name) }
                */
            },
            onGenerate: function () {

                if (this.config.action == undefined) {
                    window.location.reload();
                    return
                }
                this.$emit("action", { type: this.config.action, id: this.record._id, collection: this.$route.params.id })

            },
            onRefresh: function () {
                this.source2 = ""

                if (this.value == undefined) {
                    window.location.reload();
                    return
                }

                setTimeout(() => {
                    this.source2 = "https://files.b4food.io/b4food/files/" + this.value
                }, 200)


        
                // this.$emit("action", { type: this.config.action, id: this.record._id, collection: this.$route.params.id})

            },
            onResend: function () {

                this.$emit("action", { type: 'send-mail', id: this.record._id, collection: this.$route.params.id })

            },

            printPDF: function (pdf) {
                if (this.$refs['pdf-' + pdf.id]) { this.$refs['pdf-' + pdf.id].print() }
            },
            downloadPDF: function (base64, filename) {

                // Create an anchor element

                var link = document.createElement("a");
                link.href = base64;
                link.download = filename;
                document.body.appendChild(link);
                // Click the link
                link.click();
                // Remove the link
                document.body.removeChild(link);
            },

            OnView: function (v) {
                this.viewBy = v
                this.$nextTick(() => {
                    if (v == 2) {
                        this.$refs.pdfRef1.render()
                        this.$refs.pdfRef2.render()
                    }
                });
            },
            getData() {   }
        }
    }
</script>


<style>
    .vue-pdf-embed>div {
        margin-bottom: 8px;
        box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
    }

    .vue-pdf-embed>div>div>canvas {
        min-height: 400px;
        width: 700px
    }
</style>